import { readonly, ref } from 'vue'

const clienteNombre = ref('')

export const cuentaCorrienteClienteNombre = readonly(clienteNombre)

export const setCuentaCorrienteClienteNombre = (nombre: string) => {
  clienteNombre.value = nombre.trim()
}

export const clearCuentaCorrienteClienteNombre = () => {
  clienteNombre.value = ''
}
